// extracted by mini-css-extract-plugin
export default {"visuallyHidden":"_XI6i2"};